import Tooltip from '@components/common/Tooltip';

const Chart = () => {
    return (
        <>
            <div className="custom-card card hrm-main-card danger">
                <div className="card-body">
                    <div className="d-flex align-items-center mb-3">
                        <div className="me-3">
                            <div className="avatar avatar-md rounded-4 bg-danger shadow shadow-danger text-fixed-white">
                                <i className="ri-bubble-chart-line fs-18"></i>
                            </div>
                        </div>
                        <div className="flex-fill">
                            <p className="mb-1 text-muted">
                                광합성수분스트레스
                                <Tooltip
                                    content="도움말이 표시될예정"
                                    customClass="tooltip-dark"
                                    placement="top"
                                >
                                    <i className="ri-question-line" />
                                </Tooltip>
                            </p>
                            <div className="d-flex align-items-top justify-content-between">
                                <h5 className="fw-semibold mb-0 lh-1">낮음</h5>
                                <div className="text-danger fw-semibold">
                                    0.14
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="progress progress-lg p-1 progress-animate progress">
                        <div
                            role="progressbar"
                            className="progress-bar progress-bar-striped bg-danger progress-bar"
                            style={{ width: '14%' }}
                        ></div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Chart;
